import { render } from "./BaseAudioElementLeft.vue?vue&type=template&id=26e56554&scoped=true&ts=true"
import script from "./BaseAudioElementLeft.vue?vue&type=script&lang=ts"
export * from "./BaseAudioElementLeft.vue?vue&type=script&lang=ts"

import "./BaseAudioElementLeft.vue?vue&type=style&index=0&id=26e56554&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e56554"]])

export default __exports__